const initialState = {
  loading: false,
  data: null,
  error: null,
};

const featuresReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_FEATURES_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "FETCH_FEATURES_SUCCESS":
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case "FETCH_FEATURES_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default featuresReducer;
